import LocationForm from '../../../../LocationEditForm/Location';

export default LocationForm;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/subdirectives/edit/Location/Location.js
// module id = 365
// module chunks = 0